import { connect } from 'react-redux';
import CarrierAuthorizations from './CarrierAuthorizations';
import { resetFilters } from '../filters/store/filtersSlice';
import {
  removeCarrierAuthorization,
  resetCarrierAuthorizations,
  setFiltersOpen,
} from './store/carrierAuthorizationsSlice';
import { setMobileDrawerOpen } from '../mobile-drawer/store/mobileDrawerSlice';
import { setAuthorizationBy } from './store/createNewCarrierAuthSlice';

const mapState = state => ({
  carrierAuthorizationsCardsLength:
    state.loadingManagement.carrierAuthorizations.carrierAuthorizationsCards.length,
  filtersOpen: state.loadingManagement.carrierAuthorizations.filtersOpen,
});

const mapDispatchToProps = {
  removeCarrierAuthorization,
  resetCarrierAuthorizations,
  resetFilters,
  setAuthorizationBy,
  setFiltersOpen,
  setMobileDrawerOpen,
};

export default connect(mapState, mapDispatchToProps)(CarrierAuthorizations);
